<template>
	<div class="lunbo" v-if="bannerData.quantity>0">
		<!-- :interval="bannerData.cutover_time*1000" -->
		<el-carousel trigger="click" :height="bannerHeight+'px'" :class="'button_shape_'+bannerData.button_shape">
			<el-carousel-item v-for="(item,index) in bannerData.banners" :key="index">
				<div class="bannerContent" @click="goBanner(item.path)">
					<el-image
						style="width: 100%;"
						:src="item.image"
						class="advimg"
						fit="contain"
						@load="loadImg">
					</el-image>
				</div>
			</el-carousel-item>
		</el-carousel> 
	</div>
</template>
<script>
export default {
	name:'banner',
	props:{
		bannerData:{
			type:Object,
		},
	},
	data () {
		return {
			bannerHeight: 400,
		}
	},
	watch: {
		bannerData() {
			this.bannerDataW();
		}
	},
	mounted(){
		let that =this;
		window.addEventListener('resize',()=>{
			that.getImgH();
		})
	},
	methods:{
		bannerDataW(){
			var self = this;
			this.$nextTick(function(){
				self.getImgH();
			});
		},
		loadImg(e){
			// console.log(e.target.width,e.target.height);
			var w=document.documentElement.clientWidth || document.body.clientWidth;
			this.bannerHeight = w/(e.target.width/e.target.height);
		},
		getImgH(){
			var w=document.documentElement.clientWidth || document.body.clientWidth;
			$('.lunbo').find('.el-carousel__indicator > .el-carousel__button').css('background-color',this.bannerData.button_color);
			console.log(this.bannerData.button_color);
			let imgw = $('.bannerContent .el-image img').width();
			let imgh = $('.bannerContent .el-image img').height();
			this.bannerHeight = w/(imgw/imgh);
			console.log(this.bannerHeight);
		},
		goBanner(path){
			console.log(path);
		},
	}
}
</script>
<style scoped>
/* banner图模块 */
.lunbo{width: 100%;}
/deep/ .el-carousel__container{height: 100%;width: 100%;}
/deep/ .el-carousel__arrow{width: 50px;height: 50px;font-size: 25px;}
.bannerContent{
	width: 100%;position: relative;
}
/deep/ .button_shape_1 .el-carousel__button{width: 15px;height: 2px;}
/deep/ .button_shape_2 .el-carousel__button{width: 8px;height: 8px;border-radius: 0%;}
/deep/ .button_shape_3 .el-carousel__button{width: 10px;height: 10px;border-radius: 50%;}
</style>


// WEBPACK FOOTER //
// src/mode/banner.vue